import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { DesktopCardCaseType, MobileStateService } from '@brightside-web/desktop/data-access/shared';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';

@Injectable({
  providedIn: 'root',
})
export class ExternalLendersGuard implements CanActivate, CanLoad {
  serviceInventory = inject(ServiceInventoryService);

  constructor(private _router: Router, private _mobileStateSvc: MobileStateService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasLenderAlternativesCard();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.hasLenderAlternativesCard();
  }

  hasLenderAlternativesCard(): Observable<boolean> {
    return this.serviceInventory.getService('lender_alternatives').pipe(
      map((service) => {
        if (service) {
          return true;
        } else {
          setTimeout(() => {this._router.navigate(['home']);}, 0); // Delay to allow any pending operations to complete
          return false;
        }
      })
    );
  }
}
